module.exports = __webpack_public_path__ + "static/media/bfsi.c532c88c.png";